<template>
<div style="width: 100%; height: 90vh">
    <v-container fill-height>
        <v-row justify="center">
<v-card flat>
        <v-container style="text-align: center">
          <v-icon size="150" color="primary">mdi-checkbox-marked-circle</v-icon>
        </v-container>
        <v-container style="text-align: center">
          <h2
            :style="{
              color: $store.state.currentOrg.orderPrimaryColour
                ? $store.state.currentOrg.orderPrimaryColour
                : $store.state.currentOrg.primaryColour,
            }"
          >
            Submission Successful
          </h2>
          <h3
          v-if="!showOfInterest"
            :style="{
              color: $store.state.currentOrg.orderSecondaryColour
                ? $store.state.currentOrg.orderSecondaryColour
                : $store.state.currentOrg.secondaryColour,
            }"
          >
            Thank you for submitting your fibre order.
          </h3>
          <h3
            v-else
            :style="{
              color: $store.state.currentOrg.orderPrimaryColour
                ? $store.state.currentOrg.orderPrimaryColour
                : $store.state.currentOrg.primaryColour,
            }"
          >
            Thank you for submitting your show of interest.
          </h3>
          <br />
        </v-container>
        <v-container style="text-align: center">
          <v-btn
            medium
            color="primary"
            rounded
            @click="
              redirect()
            "
          >
            OK
          </v-btn>
        </v-container>
      </v-card>
      </v-row>
    </v-container>
        
     
</div>
</template>

<script>
export default {
    props: ['showOfInterest'],
    created(){
      setTimeout(()=>{
        this.redirect()
      },5000)
    },
    methods: {
        redirect(){
             if (this.$store.state.currentOrg.redirectUrl) {
        window.open(this.$store.state.currentOrg.redirectUrl, "_self");
      } else {
        window.location.reload(false);
      }
        }
    }

}
</script>
